export const BASE_URL = 'https://lips.org.uk';

export const OG_FALLBACK_IMAGE = `${BASE_URL}/og-image.png`;
